import { TokenListURLMap } from '@/types/TokenList';

// TODO
const tokenlists: TokenListURLMap = {
  Balancer: {
    Allowlisted:
      'https://raw.githubusercontent.com/RegenerativeFi/regenerative-token-list/refs/heads/main/celo.testnet.tokenlist.json',
  },
  External: [],
};

export default tokenlists;
